'use client'
import { FC, useEffect, useState } from 'react'
import { useScroll } from '../components/global/ScrollContext'
import { cx } from '../styles/stylebook'

interface PageLayoutProps {
  children: React.ReactNode
  scrollProgress?: boolean
  headColor?: 'white' | 'green' | 'gray'
}

const PageLayout: FC<PageLayoutProps> = ({
  children,
  scrollProgress = true,
  headColor = 'green',
}) => {
  const [isCompact, setIsCompact] = useState(false)
  const { progress, scrollY } = useScroll()

  useEffect(() => {
    setIsCompact(scrollY > 105)
  }, [scrollY])

  return (
    <>
      <div
        className={cx(
          headColor === 'green'
            ? 'bg-green-50'
            : headColor === 'gray'
              ? 'bg-system-tilebg'
              : 'bg-gray-100',
          '-z-1 -mt-[18rem] h-[calc(18rem+var(--spacing)*3)] max-md:hidden'
        )}
      ></div>
      {scrollProgress && (
        <div
          className={cx(
            'bg-system-tilebg sticky top-[var(--headerh)] z-50 flex h-1',
            //mobile
            isCompact ? 'max-md:opacity-100' : 'max-md:opacity-0',
            'max-md:fixed max-md:h-auto max-md:w-full'
          )}
          data-layer="Progress"
        >
          <div
            className={cx('h-full bg-green-50 transition-all duration-300 ease-out')}
            style={{
              width: `calc(100% * ${progress.toFixed(2)})`,
            }}
          ></div>
        </div>
      )}

      {children}
    </>
  )
}
export default PageLayout
